module.exports = __webpack_public_path__ + "front/img/login_bg.3b431698.png";